import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import service from "../../baseHttpService";
import {
  PrepareUpdateDetailWithHoldingTaxDocumentInputData,
  PrepareWithHoldingTaxDocumentInputData,
  PrepareWithHoldingTaxDocumentPublicLinkInputData,
} from "./WitholdingTaxFacade";

class WitholdingTaxService {
  DoGetWitholdingTaxDocumentPublicLink(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareWithHoldingTaxDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/WitholdingTax/GetWitholdingTaxDocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetWitholdingTaxDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareWithHoldingTaxDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/WitholdingTax/GetWitholdingTaxDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoUpdateWitholdingTaxDetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailWithHoldingTaxDocumentInputData(input),
    };
    return service.peakOnlineView
      .post("/api/WitholdingTax/UpdateWitholdingTaxDetailDocument", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new WitholdingTaxService();
